
import { defineComponent, Ref, inject } from "vue";
import { store } from "@/store";
import CloseSVG from "@/components/CloseSVG.vue";
import { ActionTypes } from "@/store/actions";

export default defineComponent({
  name: "TroubleShooting",
  components: {
    CloseSVG,
  },
  setup() {
    const closeModal = inject("closeModal") as () => void;
    const bounceTransition = inject("bounceTransition") as Ref<string>;
    const fadeTransition = inject("fadeTransition") as Ref<string>;

    const selectIssue = (issueNum: number) => {
      switch (issueNum) {
        case 1: {
          store.dispatch(ActionTypes.SET_MODAL, "smallPage");
          break;
        }
        case 2: {
          store.dispatch(ActionTypes.SET_MODAL, "shiftedVertical");
          break;
        }
        case 3: {
          store.dispatch(ActionTypes.SET_MODAL, "mismatched");
          break;
        }
        case 4: {
          store.dispatch(ActionTypes.SET_MODAL, "alignmentWizard");
          break;
        }
      }
    };

    const openContact = () => {
      store.dispatch(ActionTypes.SET_MODAL, "contact");
    };

    return {
      closeModal,
      bounceTransition,
      fadeTransition,
      selectIssue,
      openContact,
    };
  },
});
